export default "__VITE_ASSET__07Tt3tOl__"